import Notiflix from "notiflix";
import React, { useEffect, useState } from 'react';
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import "react-responsive-modal/styles.css";
import { Card, CardBody, Col, Collapse, Container, Row } from "reactstrap";
import PostApiCall from '../../../Api';
import Searchicon from "../../../assets/images/dashboardimages/search.png";
import GetApiCall from '../../../GETAPI';
export default function ProductsMappings() {
    const [itemsList, setItemsList] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    const [verticleList, setVerticleList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [subcategoryList, setSubCategoryList] = useState([]);
    const [openCollapse, setOpenCollapse] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [product, setProduct] = useState([]);
    const [searchInput, setSearchInput] = useState("")
    const [subCategoryIds, setSubCategoryIds] = useState([]);
    const [selectedFilter, setSelectedFilter] = useState("Active");
    const toggleDrawer = () => {
        setIsOpen(!isOpen)
    };
    useEffect(() => {
        GetItemsDetails();
        GetApiCall.getRequest("GetVerticleMaster").then((results) =>
            results.json().then((obj) => {
                if (results.status === 200 || results.status === 201) {
                    setVerticleList(obj.data)
                }
            }))

        GetApiCall.getRequest("Get_Category").then((results) =>
            results.json().then((obj) => {
                if (results.status === 200 || results.status === 201) {
                    setCategoryList(obj.data)
                }
            }))
        GetApiCall.getRequest("Get_Subcategory").then((results) =>
            results.json().then((obj) => {
                if (results.status === 200 || results.status === 201) {
                    setSubCategoryList(obj.data)
                }
            }))
    }, [])
    const GetItemsDetails = () => {
        PostApiCall.postRequest({
            whereClause: ``
        }, "GetItemsDetails").then((results) =>
            results.json().then((obj) => {
                if (results.status === 200 || results.status === 201) {
                    setItemsList(obj.data)
                    setFilteredItems(obj.data.filter((filter) => {
                        if (filter.fld_status == "Active") {
                            return filter
                        }
                    }))
                }
            }))
    }
    const UpdateProductMapping = () => {
        if (subCategoryIds.length > 0) {
            PostApiCall.postRequest({
                productid: product?.fld_variantid,
                SubcategoryId: subCategoryIds
            }, "UpdateProductMapping").then((results) =>
                results.json().then((obj) => {
                    if (results.status === 200 || results.status === 201) {
                        GetItemsDetails();
                        setSubCategoryIds([]);
                        setProduct([])
                        toggleDrawer();
                        Notiflix.Notify.Success("Data successfully saved")
                    }
                }))
        } else {
            Notiflix.Notify.Failure("Please choose atleast one category")
        }
    }
    const OnFilterItems = (value) => {
        setSelectedFilter(value)
        if (value == "All") {
            setFilteredItems(itemsList)
        }
        if (value == "Mapped") {
            setFilteredItems(itemsList.filter((filter) => {
                if (filter.mapped_with) {
                    return filter
                }
            }))
        }
        if (value == "UnMapped") {
            setFilteredItems(itemsList.filter((filter) => {
                if (filter.mapped_with == null || filter.mapped_with == "") {
                    return filter
                }
            }))
        }
        if (value == "Active") {
            setFilteredItems(itemsList.filter((filter) => {
                if (filter.fld_status == "Active") {
                    return filter
                }
            }))
        }
        if (value == "InActive") {
            setFilteredItems(itemsList.filter((filter) => {
                if (filter.fld_status == "InActive") {
                    return filter
                }
            }))
        }

    }
    return (
        <div className="page-content">
            <Container fluid>
                {/* <Breadcrumbs
                    breadcrumbItem={capitalizeWords(window.location.pathname.replace('/', '')).replace('-', ' ').replace('_', ' ')}
                    urlPath={"/Attribute-ist"}
                /> */}
                <Row>
                    <Col xl="12">
                        <Card className="overflow-hidden pagebackground">
                            <div className="Bechofy-bg-soft-pink">
                                <Row>
                                    <Col xs="3">
                                        <div className="Bechofy-text p-3">
                                            <h5 className="Bechofy-text pb-0 mb-0" id="upload-card">
                                                Map Products
                                            </h5>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <Card style={{ padding: "10px 20px" }}>
                                <div className="row my-1 ">
                                    <div className="col-12">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span
                                                    className="input-group-text"
                                                    id="basic-addon1"
                                                >
                                                    <span className="">
                                                        <img
                                                            src={Searchicon}
                                                            alt="block user"
                                                            className="btnicons"
                                                        ></img>
                                                    </span>
                                                </span>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Type the search phrase you wish to search within the grid"
                                                aria-label="Search"
                                                aria-describedby="basic-addon1"
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                value={searchInput}
                                            />
                                        </div>
                                        <div className='d-flex mt-2'>
                                            <p className={selectedFilter == "All" ? "btn Bechofy-btn ml-2 px-2 py-1 cursor-pointer" : 'bg-light px-2 py-1 rounded border border-dark ml-2 cursor-pointer'} onClick={() => { OnFilterItems("All") }}>All</p>
                                            <p className={selectedFilter == "Mapped" ? "btn Bechofy-btn ml-2 px-2 py-1 cursor-pointer" : 'bg-light px-2 py-1 rounded border border-dark ml-2 cursor-pointer'} onClick={() => { OnFilterItems("Mapped") }}>Mapped</p>
                                            <p className={selectedFilter == "UnMapped" ? "btn Bechofy-btn ml-2 px-2 py-1 cursor-pointer" : 'bg-light px-2 py-1 rounded border border-dark ml-2 cursor-pointer'} onClick={() => { OnFilterItems("UnMapped") }}>UnMapped</p>
                                            <p className={selectedFilter == "Active" ? "btn Bechofy-btn ml-2 px-2 py-1 cursor-pointer" : 'bg-light px-2 py-1 rounded border border-dark ml-2 cursor-pointer'} onClick={() => { OnFilterItems("Active") }}>Active</p>
                                            <p className={selectedFilter == "InActive" ? "btn Bechofy-btn ml-2 px-2 py-1 cursor-pointer" : 'bg-light px-2 py-1 rounded border border-dark ml-2 cursor-pointer'} onClick={() => { OnFilterItems("InActive") }}>InActive</p>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                            <Row>
                                <Col xl="12">
                                    <Row>
                                        {/* ======Attribute List */}
                                        {filteredItems?.filter((filter) => {
                                            if (searchInput == "") {
                                                return filter
                                            }
                                            if (searchInput != "" && filter?.fld_variantname?.toLowerCase().includes(searchInput?.toLowerCase())) {
                                                return filter
                                            }
                                        })
                                            .map((data) => {
                                                return (
                                                    <Col xs="12">
                                                        <Card>
                                                            <CardBody className="categoryCard attribut-list-border">
                                                                <Row className="card-row">
                                                                    <Col lg="2" className="px-0 mb-3">
                                                                        <img className='w-100'
                                                                            src={data?.VariantImage}
                                                                            alt=""
                                                                        />
                                                                    </Col>
                                                                    <Col lg="10">
                                                                        <h4>
                                                                            {data.fld_variantname}
                                                                        </h4>
                                                                        <p>
                                                                            Price - {data.fld_website_discount_price}
                                                                        </p>
                                                                        <p>Mapped With - {data?.mapped_with}</p>
                                                                    </Col>
                                                                    <hr className="my-3" />
                                                                </Row>
                                                                <Row className="mt-3">
                                                                    <Col sm="4" className="px-0">
                                                                        <div className="form-group">
                                                                            <p>
                                                                                <b>Status</b> -{" "}
                                                                                <span
                                                                                    style={{
                                                                                        color:
                                                                                            data.fld_status == "Active"
                                                                                                ? "green"
                                                                                                : "red",
                                                                                    }}
                                                                                >
                                                                                    {data.fld_status}
                                                                                </span>
                                                                            </p>
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg="4">
                                                                        <h5>Last Updated On - </h5>
                                                                        <p>{data?.fld_updatedon}</p>
                                                                    </Col>
                                                                    <Col sm="4" className="">
                                                                        <button
                                                                            onClick={() => {
                                                                                setIsOpen(true)
                                                                                setProduct(data)
                                                                            }}
                                                                            className="btn Bechofy-btn waves-effect waves-light btn-sm float-right"
                                                                        >
                                                                            <span className="">
                                                                                {/* <img
                                                                                    src={Editicon}
                                                                                    alt="block user"
                                                                                    className="btnicons"
                                                                                    style={{ marginRight: "5px" }}
                                                                                ></img>{" "} */}
                                                                            </span>
                                                                            Map Product
                                                                        </button>
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                )
                                            })}
                                        {/* {this.state.AttributeData.filter((data) => {
                                            if (this.state.searchInput == "") {
                                                return data;
                                            }
                                            if (
                                                this.state.searchInput !== "" &&
                                                (data.fld_attributename
                                                    .toLowerCase()
                                                    .includes(
                                                        this.state.searchInput.toLowerCase()
                                                    ) ||
                                                    `${data.fld_status
                                                        ? data.fld_status.toLowerCase()
                                                        : ""
                                                        }`.includes(
                                                            this.state.searchInput.toLowerCase()
                                                        ))
                                            ) {
                                                return data;
                                            }
                                        }).map((data, i) => (
                                        ))} */}
                                    </Row>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Drawer
                open={isOpen}
                onClose={toggleDrawer}
                direction="right"
                lockBackgroundScroll="no"
                width={450}
                className="sidebar-verticalmaster drawer flex-column p-4"
            >
                <div className='overflow-y-scroll w-100 mb-5'>
                    <h5 className="pb-2 border-bottom mb-1 sticky-top bg-white">{product?.fld_variantname}</h5>
                    {verticleList?.map((data) => {
                        return (
                            <>
                                <button
                                    className='w-100 btn Bechofy-btn Bechofy-text my-2'
                                    onClick={() => {
                                        setOpenCollapse(prevState => ({
                                            ...prevState,
                                            [data?.fld_verticleid]: !prevState[data?.fld_verticleid]
                                        }));
                                    }} id={data?.fld_verticleid}>
                                    <p className='mb-0'>
                                        {data?.fld_verticlename}
                                    </p>
                                </button>
                                <Collapse isOpen={openCollapse[data?.fld_verticleid]} id={data?.fld_verticleid} className="mb-3">
                                    {categoryList?.filter((cat) => cat.fld_vertical_id == data?.fld_verticleid).map((category) => {
                                        return (
                                            <>
                                                <div className='d-flex align-items-center my-2 border-bottom pb-2'>
                                                    {/* <img
                                                        src={category?.fld_image}
                                                        alt="block user"
                                                        className="btnicons"
                                                        style={{ "width": "100px", "height": "100px" }}
                                                    /> */}
                                                    {/* <input type="checkbox" className='mr-2' /> */}
                                                    <h5 className='mb-0'>
                                                        {category?.fld_categoryname}
                                                    </h5>
                                                </div>
                                                {subcategoryList?.filter((subcat) => category.fld_categoryid == subcat?.fld_categoryid).map((SubCategory) => {
                                                    return (
                                                        <div className='d-flex align-items-center mb-1'>
                                                            <input
                                                                type="checkbox"
                                                                className='mr-2'
                                                                checked={subCategoryIds.includes(SubCategory?.fld_subcategoryid)}
                                                                onChange={() => {
                                                                    setSubCategoryIds((prevState) => {
                                                                        if (prevState.includes(SubCategory?.fld_subcategoryid)) {
                                                                            // Remove if already present
                                                                            return prevState.filter(id => id !== SubCategory?.fld_subcategoryid);
                                                                        } else {
                                                                            // Add if not present
                                                                            return [...prevState, SubCategory?.fld_subcategoryid];
                                                                        }
                                                                    });
                                                                }}
                                                            />
                                                            <h6 className='mb-0'>
                                                                {SubCategory?.fld_subcategoryname}
                                                            </h6>
                                                        </div>
                                                    )
                                                })}
                                            </>
                                        )
                                    })}
                                </Collapse>
                            </>
                        )
                    })}
                </div>
                <div className="fixed-bottom p-3">
                    <button className='w-100 btn Bechofy-btn bg-dark Bechofy-text mb-2' onClick={UpdateProductMapping}>
                        Save
                    </button>
                </div>
            </Drawer>
        </div>
    );
}